/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Buy_AgainInputs */

const en_buy_again = /** @type {(inputs: Buy_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy Again`)
};

/** @type {(inputs: Buy_AgainInputs) => LocalizedString} */
const es_buy_again = en_buy_again;

/** @type {(inputs: Buy_AgainInputs) => LocalizedString} */
const fr_buy_again = en_buy_again;

/** @type {(inputs: Buy_AgainInputs) => LocalizedString} */
const de_buy_again = en_buy_again;

/** @type {(inputs: Buy_AgainInputs) => LocalizedString} */
const ja_buy_again = en_buy_again;

/** @type {(inputs: Buy_AgainInputs) => LocalizedString} */
const zh_buy_again = en_buy_again;

/** @type {(inputs: Buy_AgainInputs) => LocalizedString} */
const ar_buy_again = en_buy_again;

/** @type {(inputs: Buy_AgainInputs) => LocalizedString} */
const id_buy_again = en_buy_again;

/** @type {(inputs: Buy_AgainInputs) => LocalizedString} */
const it_buy_again = en_buy_again;

/** @type {(inputs: Buy_AgainInputs) => LocalizedString} */
const ru_buy_again = en_buy_again;

/** @type {(inputs: Buy_AgainInputs) => LocalizedString} */
const pt_buy_again = en_buy_again;

/** @type {(inputs: Buy_AgainInputs) => LocalizedString} */
const ko_buy_again = en_buy_again;

/**
* | output |
* | --- |
* | "Buy Again" |
*
* @param {Buy_AgainInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const buy_again = /** @type {((inputs?: Buy_AgainInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Buy_AgainInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_buy_again(inputs)
	if (locale === "es") return es_buy_again(inputs)
	if (locale === "fr") return fr_buy_again(inputs)
	if (locale === "de") return de_buy_again(inputs)
	if (locale === "ja") return ja_buy_again(inputs)
	if (locale === "zh") return zh_buy_again(inputs)
	if (locale === "ar") return ar_buy_again(inputs)
	if (locale === "id") return id_buy_again(inputs)
	if (locale === "it") return it_buy_again(inputs)
	if (locale === "ru") return ru_buy_again(inputs)
	if (locale === "pt") return pt_buy_again(inputs)
	return ko_buy_again(inputs)
});